// Luminous Intensity units with conversion factors to candela (cd)
export const luminousIntensityUnits = [
  { id: 'candela', name: 'Candela', symbol: 'cd', plural: 'Candelas', factor: 1 },
  { id: 'kilocandela', name: 'Kilocandela', symbol: 'kcd', plural: 'Kilocandelas', factor: 1000 },
  { id: 'millicandela', name: 'Millicandela', symbol: 'mcd', plural: 'Millicandelas', factor: 0.001 },
  { id: 'microcandela', name: 'Microcandela', symbol: 'µcd', plural: 'Microcandelas', factor: 0.000001 },
  { id: 'hefner-candle', name: 'Hefner Candle', symbol: 'HK', plural: 'Hefner Candles', factor: 0.9 },
  { id: 'international-candle', name: 'International Candle', symbol: 'IK', plural: 'International Candles', factor: 1.0194 },
  { id: 'decimal-candle', name: 'Decimal Candle', symbol: 'dec cd', plural: 'Decimal Candles', factor: 1 },
  { id: 'pentane-candle-10cp', name: 'Pentane Candle (10 cp)', symbol: 'pentane cd', plural: 'Pentane Candles (10 cp)', factor: 10 },
  { id: 'carcel', name: 'Carcel', symbol: 'carcel', plural: 'Carcels', factor: 9.74 },
  { id: 'bougie-decimale', name: 'Bougie Decimale', symbol: 'bd', plural: 'Bougie Decimales', factor: 1.02 },
  { id: 'lumen-per-steradian', name: 'Lumen/Steradian', symbol: 'lm/sr', plural: 'Lumen/Steradian', factor: 1 },
];

export const popularLuminousIntensityConversions = [
  { from: 'candela', to: 'millicandela' },
  { from: 'millicandela', to: 'candela' },
  { from: 'candela', to: 'kilocandela' },
  { from: 'candela', to: 'hefner-candle' },
  { from: 'lumen-per-steradian', to: 'candela' },
  { from: 'candela', to: 'international-candle' },
];

export const getUnitById = (id) => luminousIntensityUnits.find(unit => unit.id === id);

export const convertLuminousIntensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert luminous intensity units and learn the conversion formula.`;
};
